import {
  LOCAL_STORAGE_CURRENT_CUSTOMER_KEY,
  LOCAL_STORAGE_PROJECT_UUID_KEY,
} from './constants';

export const loadState = (key: string, defaultValue: any) => {
  try {
    const serializedState = localStorage.getItem(key);

    if (serializedState === null) {
      return defaultValue;
    }

    return JSON.parse(serializedState);
  } catch (error) {
    return defaultValue;
  }
};

export const saveState = (key: string, obj: any) => {
  try {
    localStorage.setItem(key, JSON.stringify(obj));
  } catch (error) {}
};

export function getCurrentCustomer() {
  try {
    const data = localStorage.getItem(LOCAL_STORAGE_CURRENT_CUSTOMER_KEY);
    if (!data) return null;

    const parsedData = JSON.parse(data);
    return parsedData;
  } catch {
    return null;
  }
}

export function getCurrentProject() {
  try {
    const data = localStorage.getItem(LOCAL_STORAGE_PROJECT_UUID_KEY);
    if (!data) return null;

    return data;
  } catch {
    return null;
  }
}
